import { PayloadAction } from '@reduxjs/toolkit';
import { ProjectsReducerCreator } from '../types';

const setProjectTodDeleteReducer = (create: ProjectsReducerCreator) => {
  return create.reducer((state, action: PayloadAction<string | null>) => {
    state.projectToDelete = action.payload;
  });
};

export default setProjectTodDeleteReducer;
